import I18n from 'I18n';
import { useCallback } from 'react';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { trackInteraction } from '../../../utils/usageTracker';
import { ClipboardIcon } from 'foundations-assets/icons/components/ClipboardIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyMessageActionButton = ({
  disabled = false,
  message,
  usageTracker,
  tooltipI18nKey
}) => {
  const onCopyButtonClick = useCallback(() => {
    trackInteraction('click-copy', '', usageTracker);
  }, [usageTracker]);
  return /*#__PURE__*/_jsx(CopyButton, {
    "data-test-id": "copy-button",
    hint: I18n.text(tooltipI18nKey),
    onClick: onCopyButtonClick,
    tooltipPlacement: "right",
    use: "transparent",
    value: message,
    disabled: disabled,
    padding: "0",
    margin: "0",
    children: /*#__PURE__*/_jsx(IconHolder, {
      icon: ClipboardIcon,
      color: disabled ? 'icon-primary-disabled' : 'icon-core-default',
      size: "300",
      paddingBlock: "100",
      paddingInline: "0",
      marginInlineStart: "100"
    })
  });
};
export default CopyMessageActionButton;